import { Controller } from 'stimulus';

export default class extends Controller {
  insertTemplate(template, container) {
    container.innerHTML = "";
    const templateContent = template.content || template;
    const clonedContent = templateContent.cloneNode(true);
    container.appendChild(clonedContent);
  }
}